import React from 'react';
import { Typography, Card, Icon, Avatar } from 'antd';
import './style.css';
import clsx from 'clsx';

const { Meta } = Card;
const { Paragraph } = Typography;

export default function QuizCard(props) {
  const {
    quizName,
    description,
    onClick,
    activeQuizIndex,
    thisQuizIndex,
  } = props;

  return (
    <Card title={quizName}
          style={{ width: 300 }}
          hoverable
          className={clsx('quiz-card', {
            'quiz-card-active': activeQuizIndex === thisQuizIndex,
          })}
          onClick={onClick}
    >
      <Paragraph>{description}</Paragraph>
    </Card>
  )
}
